import { PayloadAction } from '../../../../store.model';
import { ActionType } from '../ca-analysis-dialog.action';
import { CaAnalysisDialogState } from '../ca-analysis-dialog.state';

import { MinMax } from './min-max.action';

export function minMaxReducer(
    state: CaAnalysisDialogState,
    action: PayloadAction<ActionType.COACHING__CA__MIN_MAX, MinMax>,
): CaAnalysisDialogState {
    try {
        return {
            ...state,
            minimized: action.payload.minimized,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
